import PropTypes from 'prop-types';

export const WorkPropTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageThumbUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  user: PropTypes.shape({
    userName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    avatarUrl: PropTypes.string
  }).isRequired,
  landscape: PropTypes.bool.isRequired,
  workSizesAttributes: PropTypes.arrayOf(PropTypes.shape({
    paperWidth: PropTypes.number.isRequired,
    paperHeight: PropTypes.number.isRequired
  })).isRequired,
  printedOn: PropTypes.arrayOf(PropTypes.string).isRequired,
  isHidden: PropTypes.bool
};
